import React, {memo} from 'react'
import cx from 'classnames'

/* Utils */
import DataSet from '../../../../utils/DataSet'

/* Styles */
import s from './min-quantity.scss'

const MinQuantity = memo(({
  className,
  minimumPurchasableQuantity,
  pageTypeForDavinci,
  sku,
  merchantName,
  merchantId,
  productId,
  categoryId,
  categoryName,
  listingId,
  price
}) => {
  return (
    <div
      className={cx(s.root, className)} data-hbus={
        DataSet.createComponentViewDataForDavinci({
          pageType: pageTypeForDavinci,
          pageValue: sku,
          placement: 'buybox',
          component: 'minimumQuantity',
          componentDetail: `Bu üründen en az ${minimumPurchasableQuantity} adet satın alabilirsin.`,
          categoryHierarchy: `${categoryId} - ${categoryName}`,
          productId: productId,
          merchantName: merchantName,
          merchantId: merchantId,
          listingId: listingId,
          price: `${price}`,
        })}>
      <i className={s.icon}/>
      <span className={s.text}>
        Bu üründen <b>en az {minimumPurchasableQuantity} adet</b> satın alabilirsin.
      </span>
    </div>
  )
})

export default MinQuantity
